// AK-6776(c): No weight-bearing field exists on SalesOrder or its lines yet, so the Weight column
// described in the AC is intentionally omitted below pending a BE data source decision — this
// ships 8 columns, not 9.
import type { ColumnDef } from "@tanstack/react-table"

import { SalesOrderStatusChip } from "../components/CustomerOrderListPage/SalesOrderStatusChip"

import type { SalesOrder } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatCurrency } from "@/utils/currency"
import { formatDate } from "@/utils/date"
import { formatNumber } from "@/utils/number"
import { formatLocationAddress } from "@/utils/utils"

export const useSalesOrderPreviewColumns = (): ColumnDef<SalesOrder>[] => [
  {
    accessorKey: "publicId",
    header: "SO Number",
    cell: ({ row }) => row.original.publicId,
    enableSorting: false,
  },
  {
    accessorKey: "cpoNumbers",
    header: "CPO(s)",
    cell: ({ row }) => (row.original.cpoNumbers.length ? row.original.cpoNumbers.join(", ") : null),
    enableSorting: false,
  },
  {
    accessorKey: "shipFromWarehouseArea",
    header: "Ship From",
    cell: ({ row }) =>
      formatLocationAddress(row.original.shipFromWarehouseArea?.location, AddressFormat.LocationAndAddress) ||
      row.original.shipFromWarehouseArea?.externalSystemId ||
      null,
    enableSorting: false,
  },
  {
    accessorKey: "totalPallets",
    header: "Total Pallets",
    cell: ({ row }) => formatNumber(row.original.totalPallets, 2, 0),
    enableSorting: false,
  },
  {
    accessorKey: "totalAmount",
    header: "Amount",
    cell: ({ row }) => formatCurrency(row.original.totalAmount),
    enableSorting: false,
  },
  {
    accessorKey: "deliveryDate",
    header: "Expected Delivery",
    cell: ({ row }) => formatDate(row.original.deliveryDate),
    enableSorting: true,
  },
  {
    accessorKey: "warehouseShippedOn",
    header: "Shipped Date",
    cell: ({ row }) => formatDate(row.original.warehouseShippedOn),
    enableSorting: true,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => <SalesOrderStatusChip status={row.original.status} />,
    enableSorting: false,
  },
]
